import type { LocaleIso } from './locale';
import { getCountryByLocale } from './country';

/**
 * Builds the brand-language-country parameter string for API requests.
 * This parameter contains: brandId,languageId,countryId
 *
 * @param locale - The locale string (e.g., 'de-DE', 'fr-BE')
 * @returns A comma-separated string with brandId, languageId, and countryId
 *
 * @example
 * ```typescript
 * buildBrandLanguageCountryParam('fr-BE'); // Returns '1,24,6' (brand:1, language:24=fr, country:6=BE)
 * buildBrandLanguageCountryParam('de-DE'); // Returns '1,0,1' (brand:1, language:0=de, country:1=DE)
 * buildBrandLanguageCountryParam('en-GB'); // Returns '1,1,16' (brand:1, language:1=en, country:16=GB)
 * ```
 */
export function buildBrandLanguageCountryParam(locale: LocaleIso): string {
  const country = getCountryByLocale(locale);

  return `${country.brandId},${country.languageId},${country.countryId}`;
}
